import { WILDFLOWERS_DEFAULTS } from '@shared/core/website/headerMotion/headerMotion.catalog';

/** How many stems grow: 'meadow' about one per letter (up to 13), 'few' about 0.4 per letter (at least 3). */
export type WildflowersDensity = 'meadow' | 'few';

export type WildflowersOptions = Readonly<{
  play: 'first-visit';
  density: WildflowersDensity;
  /** Reseeds the layout; the editor's "New arrangement" adds 1. Non-negative integer. */
  arrangement: number;
}>;

/**
 * Sanitises saved Wildflowers options. Pure and never throws: unknown keys are dropped, and a missing
 * or invalid `density` / `arrangement` falls back to `WILDFLOWERS_DEFAULTS`, so a hand-edited or
 * stale blob still renders.
 */
export const parseWildflowersOptions = (raw: Readonly<Record<string, unknown>>): WildflowersOptions => {
  const { arrangement, density } = raw;
  return {
    play: WILDFLOWERS_DEFAULTS.play,
    density: density === 'few' || density === 'meadow' ? density : WILDFLOWERS_DEFAULTS.density,
    arrangement: typeof arrangement === 'number' && Number.isInteger(arrangement) && arrangement >= 0 ? arrangement : WILDFLOWERS_DEFAULTS.arrangement,
  };
};
